module.exports = __webpack_public_path__ + "static/media/close-white.5c4ab6a4.svg";